import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import withFieldValidation from 'flight/mixins/with-field-validation';
import withSingleSubmit from 'flight/mixins/with-single-submit';
import withScroll from 'flight/mixins/with-scroll';

export default defineComponent(withSingleSubmit, ValidatedForm, withFieldValidation, withScroll);

function ValidatedForm() {
    this.attributes({
        submit: '[type="submit"]',
        autoSubmitForm: false, // SingleSubmit
    });

    this.after('initialize', function() {
        this.on('click', { submit: this.attemptSubmit });
    });

    this.attemptSubmit = function(e) {
        e.preventDefault();
        this.hideErrors();
        if (this.ensureFieldsArePopulated()) {
            const isAlreadyDisabled = e.currentTarget.hasAttribute('disabled');

            this.disableButton(e);

            if (!isAlreadyDisabled) {
                this.$node.submit();
            }
        } else {
            this.scrollToElement(this.$node.find('[data-field-error]').filter(':first'));
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/ui/validated-form.js